import { useBridge } from '@onl-web/shared/bridge'

import { DialogModal } from '@/components/ui/DialogModal'

interface ErrorExitDialogProps {
  /** 모달 제목 — 기본 "알 수 없는 오류가 발생했습니다" */
  title?: string
}

/**
 * 복구 불가 오류 안내 모달 — 확인 시 웹뷰를 이탈(onPrevious)한다.
 *
 * 결과/중계 페이지의 "결과를 확인할 수 없는" 막다른 케이스(PG 결과 확인 실패·컨텍스트 유실 등)에
 * 사용한다. 자체 전체화면 대신 디자인 시스템 DialogModal 로 통일하고, 재시도 대신 앱으로 복귀시킨다.
 */
export function ErrorExitDialog({ title = '알 수 없는 오류가 발생했습니다' }: ErrorExitDialogProps) {
  const { callHandler } = useBridge()
  const exit = () => void callHandler('onPrevious', { pages: 1 })

  return (
    <DialogModal
      isOpen
      onClose={exit}
      title={title}
      confirmLabel='확인'
      onConfirm={exit}
    />
  )
}
